module.exports = __webpack_public_path__ + "media/promo/lum2021/images/inst-a1775bb29dc6df078a4c3f9e600f2cc2.png";